export const devLogger = {
  log: (...params: unknown[]) => {
    if (import.meta.env.MODE !== 'production') console.log(...params);
  },
};
